import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { OffensePlaySelection } from "./OffensePlaySelection";
import { OffenseRunLog } from "./OffenseRunLog";
import { OffensePassLog } from "./OffensePassLog";

interface Props {
  clearSelections: boolean;
  setClearSelections: (clearSelections: boolean) => void;
}

export const OffenseGameLogger = ({
  clearSelections,
  setClearSelections,
}: Props) => {
  const [expandedAccordion, setExpandedAccordion] = useState<string | false>(
    "play-selection"
  );

  const handleAccordionChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedAccordion(isExpanded ? panel : false);
    };

  useEffect(() => {
    if (clearSelections) {
      setExpandedAccordion("play-selection");
    }
  }, [clearSelections]);

  return (
    <Paper elevation={3} sx={{ p: 1 }}>
      <Box>
        <Accordion
          expanded={expandedAccordion === "play-selection"}
          onChange={handleAccordionChange("play-selection")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="play-selection-content"
            id="play-selection-header"
          >
            <Typography>Play Selection</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <OffensePlaySelection
              clearSelections={clearSelections}
              setClearSelections={setClearSelections}
            />
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expandedAccordion === "run-log"}
          onChange={handleAccordionChange("run-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="run-log-content"
            id="run-log-header"
          >
            <Typography>Run Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <OffenseRunLog
              clearSelections={clearSelections}
              setClearSelections={setClearSelections}
            />
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expandedAccordion === "pass-log"}
          onChange={handleAccordionChange("pass-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="pass-log-content"
            id="pass-log-header"
          >
            <Typography>Pass Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <OffensePassLog
              clearSelections={clearSelections}
              setClearSelections={setClearSelections}
            />
          </AccordionDetails>
        </Accordion>
      </Box>
    </Paper>
  );
};

export default OffenseGameLogger;
